import { Redirect, Route, Switch } from 'react-router-dom';

import PermissionRoute from 'components/PermissionRoute';
import NotFound from 'scenes/NotFound';

import EditProduct from './EditProduct';
import MyProducts from './MyProducts';
import NewProduct from './NewProduct';
import FreightVinculation from './NewProduct/components/Vinculate';
import { WizardStateProvider } from './NewProduct/contexts/WizardStateContext';

const NewProductWithProvider = (props: any) => (
  <WizardStateProvider>
    <NewProduct {...props} />
  </WizardStateProvider>
);

const Product = () => {
  const base = '/producer/product';
  return (
    <Switch>
      <Redirect exact to={`${base}/myproducts`} path={base} />
      <PermissionRoute
        action='myeduzz:meus-produtos:editar'
        path={`${base}/editproduct/:productId/:variationId?/:tabName(general|sales|coproducers|affiliates|delivery|infodelivery|physicaldelivery)?`}
        component={EditProduct}
      />
      <PermissionRoute
        action='myeduzz:meus-produtos:visualizar'
        path={`${base}/myproducts/:tab(approved|reproved)?`}
        component={MyProducts}
      />

      <PermissionRoute
        action='myeduzz:meus-produtos:criar'
        path={`${base}/newproduct`}
        component={NewProductWithProvider}
      />

      <Route path={`${base}/freight/vinculate`} component={FreightVinculation} />
      <Route path='*' component={NotFound} />
    </Switch>
  );
};
export default Product;
